var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { call, put, takeEvery } from 'redux-saga/effects';
import { load } from '../loaders';
import * as actions from '../actions';
import { localStorage, errorHandle } from '../services';
export function initUserSagas() {
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        return [4
        /*yield*/
        , takeEvery(actions.LOGIN, loginSaga)];

      case 1:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.GET_PRIVILEGE, getPrivilegeSaga)];

      case 2:
        _a.sent();

        return [4
        /*yield*/
        , takeEvery(actions.LOGOUT, logoutSaga)];

      case 3:
        _a.sent();

        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> 登录saga
 */

function loginSaga(action) {
  var entity, privileges, user, e_1;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        _a.trys.push([0, 3,, 5]);

        entity = action.entity, privileges = action.privileges;
        user = entity.created;
        return [4
        /*yield*/
        , put(actions.loginSuccessAction(user))];

      case 1:
        _a.sent();

        return [4
        /*yield*/
        , put(actions.getPrivilegeAction(privileges, user))];

      case 2:
        _a.sent();

        return [3
        /*break*/
        , 5];

      case 3:
        e_1 = _a.sent();
        return [4
        /*yield*/
        , put(actions.getPrivilegeFailedAction({
          message: e_1.message,
          statusCode: e_1.statusCode,
          status: e_1.status,
          stack: e_1.stack
        }))];

      case 4:
        _a.sent();

        return [3
        /*break*/
        , 5];

      case 5:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> 获取权限saga
 */


function getPrivilegeSaga(action) {
  var data, user, entity, method, apiPath, privileges, e_2;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        _a.trys.push([0, 3,, 5]);

        user = action.payload, entity = action.entity;
        method = 'get';
        apiPath = entity.metainfo.apiPath;
        data = {
          apiPath: apiPath,
          params: {}
        };
        return [4
        /*yield*/
        , call(load, method, data)];

      case 1:
        privileges = _a.sent();
        user = __assign(__assign({}, user), {
          privileges: privileges
        });
        localStorage.set('user', user);
        return [4
        /*yield*/
        , put(actions.getPrivilegeSuccessAction(user))];

      case 2:
        _a.sent();

        window.location.hash = '#/';
        return [3
        /*break*/
        , 5];

      case 3:
        e_2 = _a.sent();
        errorHandle(e_2);
        return [4
        /*yield*/
        , put(actions.getPrivilegeFailedAction({
          request: data,
          message: e_2.message,
          statusCode: e_2.statusCode,
          status: e_2.status,
          stack: e_2.stack
        }))];

      case 4:
        _a.sent();

        return [3
        /*break*/
        , 5];

      case 5:
        return [2
        /*return*/
        ];
    }
  });
}

function logoutSaga() {
  var e_3;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        _a.trys.push([0, 2,, 4]);

        localStorage.remove('user');
        return [4
        /*yield*/
        , put(actions.logoutSuccessAction())];

      case 1:
        _a.sent();

        window.location.hash = '#/';
        return [3
        /*break*/
        , 4];

      case 2:
        e_3 = _a.sent();
        return [4
        /*yield*/
        , put(actions.logoutFailedAction({
          message: e_3.message,
          statusCode: e_3.statusCode,
          status: e_3.status,
          stack: e_3.stack
        }))];

      case 3:
        _a.sent();

        return [3
        /*break*/
        , 4];

      case 4:
        return [2
        /*return*/
        ];
    }
  });
}